

  

jQuery('.hero-slide').slick({
    infinite: true,
    fade:true,
    autoplay:true,
    autoplaySpeed: 5000,
    dots:true, 
    arrows:false,
  }); 
        

  jQuery('.affiliates-slick').slick({
    infinite:true,
    slidesToShow: 8,
    autoplay:false,
    nav:false,
    arrows:false,
       responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          autoplay:true,
          autoplaySpeed:4000,
          
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          autoplay:true,
          autoplaySpeed:4000,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplay:true,
          autoplaySpeed:4000,
          
        }
      }
    ]
  });

  jQuery('.media-logos__slider').slick({
    infinite:true,
    slidesToShow:4,
    slidesToScroll:1,
    autoplay:true,
    arrows:false,
    dots:false,
    responsive: [
      {
        breakpoint:830,
        settings:{
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplay:true,
          autoplaySpeed:4000,
        }
      },


    ]
  });

  // jQuery('.home-news-slick').slick({
  //   infinite:true,
  //   slidesToShow: 6, 
  //   slidesToScroll:1,
  //   autoplay:false,
  //   nav:false,
  //   arrows:false,
  //   settings:true,
  //   responsive: [
  //     {
  //       breakpoint: 1700,
  //       settings: {
  //         slidesToShow: 5,
  //         slidesToScroll: 3,
  //         autoplay:true,
  //         autoplaySpeed:4000,
          
  //       }
  //     },
  //     {
  //       breakpoint: 1330,
  //       settings: {
  //         slidesToShow: 4,
  //         slidesToScroll: 4,
  //         autoplay:true,
  //         autoplaySpeed:4000,
  //       }
  //     },
  //     {
  //       breakpoint: 1000,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         autoplay:true,
  //         autoplaySpeed:4000,
          
  //       }
  //     },
  //     {
  //       breakpoint:830,
  //       settings:{
  //         slidesToShow: 2,
  //         slidesToScroll: 2,
  //         autoplay:true,
  //         autoplaySpeed:4000,
  //       }
  //     },
  //     {
  //       breakpoint:560,
  //       settings:{
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         autoplay:true,
  //         autoplaySpeed:5000,
  //       }
  //     }

  //   ]

  // })

  jQuery(function() {
    var classes = ["show-front", "show-right-side", "show-left-side","show-back"];
    var arrayIndex = 0;
  
    var renderInterval = setInterval(function() {
      var $btn = jQuery('.promo__holder');
      $btn.removeClass(classes.join(" ")).addClass(classes[arrayIndex]);
      arrayIndex += 1;
      if (arrayIndex >= classes.length) {
  
        arrayIndex = 0;
      }
    }, 2500);
  }); 


jQuery(document).ready(function(){
  'use strict';
  
  
    // search & highlight
  
    ;( function( $, window, document, undefined )
    {
      var $container = $( '.theatres-block' );
      if( !$container.length ) return true;
  
      var $input			= $container.find( 'input' ),
        $notfound		= $container.find( '.theatres-block__not-found' ),
        $items			= $container.find( '> ul > li' ),
        $item			= $(),
        itemsIndexed	= [];
  
      $items.each( function()
      {
        itemsIndexed.push( $( this ).text().replace( /\s{2,}/g, ' ' ).toLowerCase() );
      });
  
      $input.on( 'keyup', function( e )
      {
        if( e.keyCode == 13 ) // enter
        {
          $input.trigger( 'blur' );
          return true;
        }
  
        $items.each( function()
        {
          $item = $( this );
          $item.html( $item.html().replace( /<span class="highlight">([^<]+)<\/span>/gi, '$1' ) );
        });
  
        var searchVal = $.trim( $input.val() ).toLowerCase();
        if( searchVal.length )
        {
          for( var i in itemsIndexed )
          {
            $item = $items.eq( i );
            if( itemsIndexed[ i ].indexOf( searchVal ) != -1 )
              $item.removeClass( 'is-hidden' ).html( $item.html().replace( new RegExp( searchVal+'(?!([^<]+)?>)', 'gi' ), '<span class="highlight">$&</span>' ) );
            else
              $item.addClass( 'is-hidden' );
          }
        }
        else $items.removeClass( 'is-hidden' );
  
        $notfound.toggleClass( 'is-visible', $items.not( '.is-hidden' ).length == 0 );
      });
    })( jQuery, window, document );
  
  
    // toggling items on title press
  
    ;( function( $, window, document, undefined )
    {
      $( document ).on( 'click', '.theatres-block h2 a', function( e )
      {
        e.preventDefault();
        $( this ).parents( 'li' ).toggleClass( 'is-active' );
      });
    })( jQuery, window, document );
  
  
    // auto-show item content when show results reduces to single
  
    ;( function( $, window, document, undefined )
    {
      var $container = $( '.theatres-block' );
      if( !$container.length ) return true;
  
      var $input		= $container.find( 'input' ),
        $items		= $container.find( '> ul > li' ),
        $item		= $();
  
      $input.on( 'keyup', function()
      {
        $item = $items.not( '.is-hidden' );
        if( $item.length == 1 )
          $item.addClass( 'js--autoshown is-active' );
        else
          $items.filter( '.js--autoshown' ).removeClass( 'js--autoshown is-active' );
      });
    })( jQuery, window, document );
  

});


// jQuery(window).scroll(function() {
//   if (jQuery(this).scrollTop() >= 900) {
//       jQuery('.cta').css('right','-200px');
//       setTimeout(function(){
//         jQuery('.cta').addClass('cta--open');
//       },300);
//   }
//   else {
//       jQuery('.cta').css('right','-4px');
//     setTimeout(function(){
//     jQuery('.cta').removeClass('cta--open');

//   },300);



//   }
// });
  
jQuery('.scrolltocontent').on('click', function (e) {
	e.preventDefault();

	jQuery('html, body').animate({ 
		scrollTop: jQuery(jQuery(this).attr('href')).offset().top
	}, 500, 'linear');
});

jQuery('.mobile-menu').click(function(){

jQuery('.menu').toggleClass('flex');
jQuery('.header').toggleClass('mob-menu');
jQuery('.socials').toggleClass('mob-menu-active');
})



document.addEventListener('DOMContentLoaded',function(){
  var el = document.querySelectorAll('img');
  el.forEach(element => { 
    element.classList.add("lozad")
  
  });
  var observer = lozad();
  observer.observe();

var img = document.querySelector('.lozad');
observer.triggerLoad(img);
})





if (jQuery(window).width() < 960) {

  window.onscroll = function(ev) {
    if ((window.innerHeight + window.scrollY + 1000) >= document.body.offsetHeight) {
       jQuery('.back-to-top').fadeIn();
    }
    else{
      jQuery('.back-to-top').fadeOut();
    }
  };
}
else {
  jQuery('.back-to-top').fadeOut();
}

var arrow = document.querySelector('.back-to-top');
arrow.addEventListener('click',function(){
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
})





document.addEventListener('DOMContentLoaded',function(){
    AOS.init();
})